/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { findListingEntity } from './helpers/entityReadHelpers';
import { upsertListing, upsertListingVariant } from './helpers/entityAdapter';

export const removeVariantLiveSnapshot = createAsyncThunk(
  'products/removeVariantLiveSnapshot',
  async ({ masterProductId, channelId, variantId }, { extra: { Logger, Toast, sdk } }) => {
    try {
      await sdk.products.deleteVariantLiveSnapshot(variantId);
      return { masterProductId, channelId, variantId };
    } catch (error) {
      Toast('Cannot remove live from variant. Refresh and try again', { type: 'error', autoClose: false });
      Logger.error(new Error('Error removing live from listing variant'), { error }, [
        'RemoveVariantLiveSnapshotFailed',
        { errorMessage: 'Live data not removed on backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(removeVariantLiveSnapshot.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(removeVariantLiveSnapshot.fulfilled, (state, { payload }) => {
      const { masterProductId, channelId, variantId } = payload;
      state.isBusy = false;

      const existingListing = findListingEntity(state, { masterProductId, channelId });

      upsertListingVariant(state, {
        ...(state.entities?.listingVariants?.[variantId] || {}),
        _id: variantId,
        live: null,
      });

      if (existingListing?._id && existingListing.live) {
        upsertListing(state, {
          ...existingListing,
          masterProductId,
          live: {
            ...existingListing.live,
            variants: (existingListing.live.variants || []).filter(({ _id }) => _id !== variantId),
          },
        });
      }
    })
    .addCase(removeVariantLiveSnapshot.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot remove live from variant';
    });
};
